module.exports = __webpack_public_path__ + "img/VIP-3.1bf4b16b.png";